import * as React from 'react'
import { Backdrop, CircularProgress, Typography, makeStyles, Theme } from '@material-ui/core'

export type LoadingProps = {
    show: boolean,
    message: string
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        color: '#fff',
        zIndex: 1400,
        flexDirection: 'column'
    }
}))

function Loading({ show, message }: LoadingProps) {

    const classes = useStyles()

    return <Backdrop className={classes.root} open={show} >
        <CircularProgress color="secondary" />
        <Typography style={{marginTop: '20px',padding: '0 32px',boxSizing: 'border-box',textAlign: 'center'}} variant="body1" color="inherit">
            {message}
        </Typography>
    </Backdrop>
}

export default Loading